import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Top-Nav-Small" }
const _hoisted_2 = { class: "App-M-Top-Nav-Sm-H" }
const _hoisted_3 = { class: "App-M-Top-Nav-Logo" }
const _hoisted_4 = { class: "App-M-Top-Nav-Menu" }
const _hoisted_5 = { class: "App-M-Top-Nav-R" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_logo = _resolveComponent("app-logo")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_get_started = _resolveDirective("get-started")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, {
      class: "hidden-lg-and-up",
      offset: 0
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_logo, {
            style: {"line-height":"50px"},
            size: 50
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              icon: "el-icon-menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = true)),
              "is-all-borderless": "",
              plain: ""
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Menu ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.isOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isOpen) = $event)),
      withHeader: false,
      direction: "ltr",
      size: "300px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_space, {
            class: "App-Top-Nav-Small-Spacer",
            alignment: "space-between",
            direction: "vertical",
            size: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_app_logo, { size: 60 })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_space, {
                  direction: "vertical",
                  size: 16
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `menu-link${link.url}`
                      }, [
                        _createVNode(_component_router_link, {
                          class: "App-M-Top-Nav-Link",
                          to: link.url
                        }, {
                          default: _withCtx(({ isExactActive }) => [
                            _createVNode(_component_el_link, {
                              class: _normalizeClass(["Nav-Link", isExactActive ? 'active' : 'inactive']),
                              type: isExactActive ? 'primary' : 'default'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "type"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_space, {
                  direction: "vertical",
                  size: 12
                }, {
                  default: _withCtx(() => [
                    (_ctx.showGetStarted)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          icon: "el-icon-right",
                          type: "primary",
                          size: "large"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" Get Started ", -1)
                          ]))]),
                          _: 1
                        })), [
                          [_directive_get_started]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      icon: "el-icon-user",
                      onClick: _ctx.navigateToSignIn,
                      "is-all-borderless": "",
                      plain: "",
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Sign In ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}